@if (!isActiveMode) {
  <button type="button" class="btn btn-success mr-2" [disabled]="!canActivate" (click)="onActivation(true)">Activa el servicio @if (isLoading) {
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  }</button>
}
@if (isActiveMode) {
  <button type="button" class="btn btn-secondary" (click)="onActivation(false)">Desactivar el servicio @if (isLoading) {
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  }</button>
}